import { IApplicationState } from '../../types/redux';

export const selectSaveOfferResult = (state: IApplicationState) => state.calculator.saveOfferResult;
